// extracted by css-extract-rspack-plugin
export default {"BackToRepositorySelectionButton":"RepositoryAndIssuePicker-module__BackToRepositorySelectionButton__pOSHR9Y"};